/**
 * Route copy for `src/routes/forms` (keys: `routes.forms.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  formPublicApi: {
    firstName: 'First name',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    serviceTemporarilyUnavailable: 'Service temporarily unavailable.',
  },
  publicFormPage: {
    poweredByKarexia: 'Powered by Karexia ·',
    privacyPolicy: 'Privacy policy',
    thisFormIsTemporarilyUnavailableTry: 'This form is temporarily unavailable. Try again.',
    consentIsRequiredToSubmitThis: 'Consent is required to submit this form.',
    sendingFailedCheckTheFieldsAnd: 'Sending failed. Check the fields and try again.',
    loading: 'Loading…',
    formNotFound: 'Form not found',
    thisFormLinkIsInvalidOr: 'This form link is invalid or no longer active. Contact the person who sent it to you to get a new one.',
    formTemporarilyUnavailable: 'Form temporarily unavailable',
    anErrorOccurred: 'An error occurred.',
    tryAgain: 'Try again',
    thankYou: 'Thank you!',
    yourInformationHasBeenUpdated: 'Your information has been updated.',
    yourAnswerHasBeenRecorded: 'Your answer has been recorded.',
    quiz: 'Quiz',
    form: 'Form',
    iAgreeToReceiveCommunicationsI: 'I agree to receive communications. I can unsubscribe at any time.',
    sending: 'Sending…',
    send: 'Send',
    bySubmittingThisFormYouAgree: 'By submitting this form, you agree that the information provided will be processed by the organization that sent it to you, in accordance with its',
    privacyPolicy2: 'privacy policy',
    youCanRequestAccessToCorrection: '. You can request access to, correction or deletion of your data at any time.',
    poweredByKarexia2: 'Powered by Karexia',
    almostDoneOpenTheConfirmationEmail: 'Almost done! Open the confirmation email we just sent and click the link to get your position.',
  },
};

export default en;
